/* MTi GROUP — Header V2 behavior
   Mega menu open/close, mobile drawer, search overlay, popover toggles. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.mtiV2Inited === '1') return;
    root.dataset.mtiV2Inited = '1';

    const headerEl = root;
    const navItems = root.querySelectorAll('.mti-v2-nav__item[data-mega]');
    const megaEl = root.querySelector('.mti-v2-mega');
    const megaPanels = root.querySelectorAll('.mti-v2-mega__panel');
    const backdrop = document.querySelector('.mti-v2-mega-backdrop');

    let closeTimer = null;
    let activeMenu = null;

    function setActive(name) {
      activeMenu = name;
      navItems.forEach(item => {
        item.classList.toggle('is-open', item.dataset.mega === name);
        const trigger = item.querySelector('.mti-v2-nav__trigger');
        if (trigger) trigger.setAttribute('aria-expanded', item.dataset.mega === name ? 'true' : 'false');
      });
      megaPanels.forEach(p => {
        p.classList.toggle('is-active', p.dataset.panel === name);
      });
      if (megaEl) megaEl.classList.toggle('is-open', !!name);
      if (backdrop) backdrop.classList.toggle('is-open', !!name);
    }

    function open(name) {
      clearTimeout(closeTimer);
      setActive(name);
    }
    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => setActive(null), 160);
    }
    function closeNow() {
      clearTimeout(closeTimer);
      setActive(null);
    }

    navItems.forEach(item => {
      const name = item.dataset.mega;
      item.addEventListener('mouseenter', () => open(name));
      item.addEventListener('mouseleave', scheduleClose);
      const trigger = item.querySelector('.mti-v2-nav__trigger');
      if (trigger) {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          if (activeMenu === name) closeNow(); else open(name);
        });
      }
    });

    if (megaEl) {
      megaEl.addEventListener('mouseenter', () => open(activeMenu));
      megaEl.addEventListener('mouseleave', scheduleClose);
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeNow();
    });

    // Shop panel tabs
    const tabBtns = root.querySelectorAll('.mti-v2-mm-tab');
    const tabPanes = root.querySelectorAll('.mti-v2-mm-tabpane');
    tabBtns.forEach(btn => {
      const id = btn.dataset.tab;
      const activate = () => {
        tabBtns.forEach(b => b.classList.toggle('is-active', b.dataset.tab === id));
        tabPanes.forEach(p => p.classList.toggle('is-active', p.dataset.tab === id));
      };
      btn.addEventListener('mouseenter', activate);
      btn.addEventListener('click', (e) => { e.preventDefault(); activate(); });
    });

    // Featured product hover-swap (Shop > Category).
    // Falls back to the first card when the hovered category has no
    // matching featured product, so the slot is never blank.
    const featuredSlots = root.querySelectorAll('[data-featured-slot]');
    const featuredCards = root.querySelectorAll('[data-featured-card]');
    const featuredKeys = Array.from(featuredCards).map(c => c.dataset.featuredCard);
    function showFeatured(key) {
      if (!featuredCards.length) return;
      const target = featuredKeys.indexOf(key) >= 0 ? key : featuredKeys[0];
      featuredCards.forEach(card => {
        card.style.display = card.dataset.featuredCard === target ? '' : 'none';
      });
    }
    if (featuredKeys.length) showFeatured(featuredKeys[0]);
    featuredSlots.forEach(row => {
      row.addEventListener('mouseenter', () => {
        showFeatured(row.dataset.featuredSlot);
      });
    });

    // Scroll shadow + auto-hide on scroll down, show on scroll up.
    // Mirrors the legacy <sticky-header> mechanic from header.liquid:
    //   - .mti-v2-header-section is position:sticky;top:0 (CSS).
    //   - Hide => set top: -header-height via .is-header-hidden class.
    //   - Reveal => remove the class.
    // Headers' Shopify section wrapper (.mti-v2-header-section) is what
    // actually carries position:sticky, so it reserves space in flow and
    // content never starts beneath it.
    const sectionEl = headerEl.closest('.mti-v2-header-section') || headerEl.parentElement;

    // Expose the header's measured height as --mti-v2-header-offset so
    // sticky descendants (filter bars, in-page anchors) can offset by it.
    const measureHeader = () => {
      if (!sectionEl) return;
      const h = sectionEl.getBoundingClientRect().height;
      if (h > 0) {
        document.documentElement.style.setProperty('--mti-v2-header-offset', h + 'px');
      }
    };
    measureHeader();
    window.addEventListener('load', measureHeader);
    window.addEventListener('resize', measureHeader);
    if ('ResizeObserver' in window && sectionEl) {
      const ro = new ResizeObserver(measureHeader);
      ro.observe(sectionEl);
    }

    let scrolled = false;
    let hidden = false;
    let lastY = window.scrollY;
    const DELTA = 4;
    const onScroll = () => {
      const y = window.scrollY;

      const isScrolled = y > 30;
      if (isScrolled !== scrolled) {
        scrolled = isScrolled;
        headerEl.classList.toggle('is-scrolled', scrolled);
      }

      const headerHeight = sectionEl ? sectionEl.getBoundingClientRect().height : 90;
      const dy = y - lastY;
      if (Math.abs(dy) > DELTA) {
        const menuOpen = headerEl.classList.contains('is-mega-open') || headerEl.classList.contains('is-drawer-open');
        if (dy > 0 && y > headerHeight && !hidden && !menuOpen) {
          hidden = true;
          sectionEl && sectionEl.classList.add('is-header-hidden');
        } else if (dy < 0 && hidden) {
          hidden = false;
          sectionEl && sectionEl.classList.remove('is-header-hidden');
        }
        lastY = y;
      }

      // At the very top of the page, always reveal — matches legacy reset().
      if (y <= 0 && hidden) {
        hidden = false;
        sectionEl && sectionEl.classList.remove('is-header-hidden');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Popovers (currency, account)
    const popoverTriggers = root.querySelectorAll('[data-popover-trigger]');
    popoverTriggers.forEach(trigger => {
      const targetId = trigger.dataset.popoverTrigger;
      const target = root.querySelector('[data-popover="' + targetId + '"]');
      if (!target) return;
      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        const willOpen = !target.classList.contains('is-open');
        // close others
        root.querySelectorAll('.mti-v2-popover.is-open').forEach(p => p.classList.remove('is-open'));
        target.classList.toggle('is-open', willOpen);
      });
    });
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.mti-v2-popover') && !e.target.closest('[data-popover-trigger]')) {
        root.querySelectorAll('.mti-v2-popover.is-open').forEach(p => p.classList.remove('is-open'));
      }
    });

    // Search trigger — opens the V1 Dawn-style <details-modal> rendered
    // via the header-search snippet. The V1 <summary> is hidden via CSS;
    // we forward the click so all the existing predictive-search wiring
    // (search-form.js, predictive-search.js, details-modal.js) just works.
    const searchTrigger = root.querySelector('[data-search-trigger]');
    const v1SearchSummary = root.querySelector('.mti-v2-header__search-host details-modal > details > summary');
    if (searchTrigger && v1SearchSummary) {
      searchTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        // Stop the click from bubbling — details-modal.js attaches a body
        // click handler in open() that would treat this same event as a
        // click-outside and immediately close the modal it just opened.
        e.stopPropagation();
        v1SearchSummary.click();
      });
    }

    // Patch predictive-search auto-close behavior. The Dawn predictive-search
    // calls close() on focusout if document.activeElement isn't inside the
    // <predictive-search> element. Inside the V2 search modal that check
    // misfires during the moment innerHTML is swapped in renderSearchResults,
    // making the dropdown flash on then immediately disappear. Override the
    // close() method to bail whenever the input still has a query value —
    // natural close paths (ESC, click outside the modal, clearing the input)
    // still work because:
    //   • details-modal closes the whole modal on outside-click / ESC
    //     (predictive-search's [open] state stops mattering once parent
    //     <details> loses its [open]).
    //   • onChange explicitly calls close(true) when the term is empty,
    //     and we honor close(true).
    const v1Predictive = root.querySelector('.mti-v2-header__search-host predictive-search');
    if (v1Predictive && typeof v1Predictive.close === 'function') {
      const originalClose = v1Predictive.close.bind(v1Predictive);
      v1Predictive.close = function (clearSearchTerm = false) {
        if (clearSearchTerm) return originalClose(true);
        const input = this.querySelector('input[type="search"]');
        const hasQuery = input && input.value.trim().length > 0;
        if (hasQuery) return; // dropdown stays open as long as there's a query
        return originalClose(false);
      };
    }

    // Mobile drawer
    const drawer = document.querySelector('.mti-v2-drawer');
    const drawerBackdrop = document.querySelector('.mti-v2-drawer-backdrop');
    const drawerOpen = root.querySelector('[data-drawer-open]');
    const drawerClose = drawer && drawer.querySelector('[data-drawer-close]');
    const drawerSections = drawer && drawer.querySelectorAll('.mti-v2-drawer__section');
    const drawerNavBtns = drawer && drawer.querySelectorAll('[data-drawer-nav]');
    const drawerBack = drawer && drawer.querySelector('[data-drawer-back]');

    function showSection(name) {
      if (!drawerSections) return;
      drawerSections.forEach(s => s.classList.toggle('is-active', s.dataset.section === name));
      if (drawerBack) drawerBack.style.display = name === 'root' ? 'none' : '';
    }

    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawerBackdrop && drawerBackdrop.classList.add('is-open');
      showSection('root');
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawerBackdrop && drawerBackdrop.classList.remove('is-open');
    }

    if (drawerOpen) drawerOpen.addEventListener('click', openDrawer);
    if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
    if (drawerBackdrop) drawerBackdrop.addEventListener('click', closeDrawer);
    if (drawerNavBtns) {
      drawerNavBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          showSection(btn.dataset.drawerNav);
        });
      });
    }
    if (drawerBack) drawerBack.addEventListener('click', () => showSection('root'));
    showSection('root');
  }

  function bootAll() {
    document.querySelectorAll('.mti-v2-header').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  // Re-init on Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('.mti-v2-header');
    if (root) init(root);
  });
})();
